import React from "react";
// ANT DESIGN COMPONENTS
import { Spin, Switch } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { faBell } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { usePutUserMutation } from "../../redux/users/userAPI";
import { updateUserLogged } from "../../redux/home/homeSlice";
// COMPONENTS
import DrawerRowDivider from "../components/drawer/DrawerRowDivider";
// INTERFACES
import { RootState } from "../../app/store";
import { UserLoggedInterface } from "../../interfaces/User.interface";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";

function AppNotifications() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");
  const dispatch = useDispatch();

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);
  const { userLogged } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [putUser, { isLoading }] = usePutUserMutation();

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChangeNotification = async (type: "application" | "command", newValue: boolean) => {
    // Save new value in local
    const copy: UserLoggedInterface = structuredClone(userLogged);
    const token = await GETJwtToken();
    if (type === "command") {
      copy.commandNotifications = newValue;
    }
    if (type === "application") {
      copy.globalNotifications = newValue;
    }
    dispatch(updateUserLogged(copy));
    const BODY = {
      id: userLogged.id,
      token,
      body: {
        command_notifications: copy.commandNotifications,
        global_notifications: copy.globalNotifications,
      },
    };
    putUser(BODY);
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <br />
      {/** ************************************************* */}
      {/** COMPONENT DRAWER DIVIDER */}
      <DrawerRowDivider icon={faBell} title={t("general.notification")} />
      <div className={`drawer__box__${theme}`}>
        <Spin spinning={isLoading}>
          {/** ENABLE APPLICATION NOTIFICATIONS */}
          <div className="col-md-12 mt-1">
            <div className="generalStyles__flex">
              <div className="generalStyles__inputFlexNameLarge">
                {t("general.appNotifications")}
              </div>
              <div className="generalStyles__width100">
                <Switch
                  checked={userLogged.globalNotifications}
                  onChange={(e) => {
                    onChangeNotification("application", e);
                  }}
                />
              </div>
              <div style={{ width: "52px" }} />
            </div>
          </div>
          {/** ENABLE COMMANDS NOTIFICATIONS */}
          <div className="col-md-12 mt-3">
            <div className="generalStyles__flex">
              <div className="generalStyles__inputFlexNameLarge">
                {t("general.commandNotifications")}
              </div>
              <div className="generalStyles__width100">
                <Switch
                  checked={userLogged.commandNotifications}
                  onChange={(e) => {
                    onChangeNotification("command", e);
                  }}
                />
              </div>
              <div style={{ width: "52px" }} />
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
}

export default AppNotifications;
